module.exports = __webpack_public_path__ + "img/result_txt_kh.ca7dc19f.png";